var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "base-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-card-title",
                    [
                      _vm._v(" Listados Credenciales TEF "),
                      _c("v-spacer"),
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: "Buscar",
                          "single-line": "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                      _c("v-spacer"),
                    ],
                    1
                  ),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.details,
                      search: _vm.search,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.type_tef`,
                          fn: function ({ item }) {
                            return [
                              item.type_tef === 1
                                ? _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-0 mr-2 black--text v-chip v-chip--label theme--light v-size--small yellow lighten-4",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "v-chip__content" },
                                          [_vm._v(" CREDIBANCO ")]
                                        ),
                                      ]
                                    ),
                                    _c("strong", [_vm._v("Smartpos")]),
                                  ])
                                : item.type_tef === 2
                                ? _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-0 mr-2 black--text v-chip v-chip--label theme--light v-size--small dark lighten-4",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "v-chip__content" },
                                          [_vm._v(" CREDIBANCO ")]
                                        ),
                                      ]
                                    ),
                                    _c("strong", [_vm._v("Aplicaciones")]),
                                  ])
                                : item.type_tef === 3
                                ? _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-0 mr-2 black--text v-chip v-chip--label theme--light v-size--small blue lighten-4",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "v-chip__content" },
                                          [_vm._v(" CREDIBANCO ")]
                                        ),
                                      ]
                                    ),
                                    _c("strong", [_vm._v("Smartpos Sin Id")]),
                                  ])
                                : item.type_tef === 4
                                ? _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-0 mr-2 black--text v-chip v-chip--label theme--light v-size--small purple lighten-4",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "v-chip__content" },
                                          [_vm._v(" CREDIBANCO ")]
                                        ),
                                      ]
                                    ),
                                    _c("strong", [_vm._v("Tramas")]),
                                  ])
                                : item.type_tef === 6
                                ? _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-0 mr-2 black--text v-chip v-chip--label theme--light v-size--small green lighten-4",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "v-chip__content" },
                                          [_vm._v(" REDEBAN ")]
                                        ),
                                      ]
                                    ),
                                    _c("strong", [_vm._v("Aplicaciones")]),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: `item.terminales`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: `/app/administration/tefConfigTerminales?Tef=${item.type_tef}&Client=${item.client}`,
                                  },
                                  nativeOn: { click: function ($event) {} },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { color: "info darken-3" },
                                    },
                                    [_vm._v(" mdi-desktop-classic ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }